import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  TextField,
  Select,
  FormControl,
  InputLabel,
  Box,
  Modal,
  IconButton,
  Typography,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Close } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useUpdate, useDelete } from "../../hooks";
import {
  convertDate,
  convertYearMonthDateToMonthDateYear,
} from "../../utils/DateFormats";
import { validateDate } from "../../utils/textFieldValidations";

const AdminVendorAddBanners = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [open, setOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [bannerForm, setBannerForm] = useState({
    name: "",
    image: "",
    vendorId: "",
    vendorName: "",
    startDate: "",
    endDate: "",
    marketingPrice: "",
  });
  const [selectedBannerId, setSelectedBannerId] = useState(null);
  const [isEditMode, setEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [data, setData] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const loginToken = useSelector((state) => state.user.logintoken);
  const [errors, setErrors] = useState({});
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const clearErrors = () => {
    setErrors({});
  };
  const [selectedImage, setSelectedImage] = useState(null);
  const userDetails = useSelector((state) => state.user.userdetails);

  const initializeBanners = () => {
    setBannerForm({
      name: "",
      image: "",
      vendorId: "",
      vendorName: "",
      startDate: "",
      endDate: "",
      marketingPrice: "",
      reason: "",
    });
  };
  //get All Banners data
  useEffect(() => {
    fetchData();
  }, []);

  //get All Banners data
  const {
    data: bannersData,
    isLoading: isBannersLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllAdminVendorBanners"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: updateBannersData,
    isLoading: updateBannersLoading,
    error: updateBannersError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: deleteBannersData,
    isLoading: deleteBannersLoading,
    error: deleteBannersError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  useEffect(() => {
    if (error) {
    } else if (bannersData && bannersData["status"] === true) {
      console.log("bannerdata", bannersData);
      setData(bannersData["data"] || []); 
    }
  }, [bannersData, error]);

  //Update Banners
  useEffect(() => {
    if (updateBannersError) {
    } else if (updateBannersData && updateBannersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateBannersData["message"],
        status: updateBannersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateBannersData && updateBannersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateBannersData["message"],
        status: updateBannersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateBannersData, updateBannersError]);

  //Delete Banners
  useEffect(() => {
    if (deleteBannersError) {
    } else if (deleteBannersData && deleteBannersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteBannersData["message"],
        status: deleteBannersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteBannersData && deleteBannersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteBannersData["message"],
        status: deleteBannersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteBannersData, deleteBannersError]);

  const handleSearch = (event) => setSearch(event.target.value);

  const handleMenuOpen = (event, banner) => {
    setAnchorEl(event.currentTarget);
    setSelectedBannerId(banner);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleView = (bannerData) => {
    setEditMode(true);
    setOpen(true);
    setBannerForm({
      ...bannerForm,
      vendorId: bannerData["vendor_id"],
      name: bannerData["name"],
      startDate: convertYearMonthDateToMonthDateYear(bannerData["start_date"]),
      endDate: convertYearMonthDateToMonthDateYear(bannerData["end_date"]),
      marketingPrice: bannerData["offer_price"],
      image: bannerData["image_url"],
      status:
        bannerData["status"] === 1
          ? "Active"
          : bannerData["status"] === 0
          ? "Inactive"
          : "",
      id: bannerData["vbanner_id"],
      reason: bannerData["reason"] ? bannerData["reason"] : "",
    });
    setAnchorEl(null);
  };

  const handleDelete = (bannerId) => {
    const deleteUrl = urls("deleteAdminVendorBanners", bannerId);
    fetchDeleteData(deleteUrl);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setBannerForm({
      name: "",
      image: "",
      vendorId: "",
      vendorName: "",
      startDate: "",
      endDate: "",
      reason: "",
    });
    setEditMode(false);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      setBannerForm({
        ...bannerForm,
        image: URL.createObjectURL(e.target.files[0]),
      });
      setSelectedImage(file);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // Filter data based on search
  const filteredData =
    Array.isArray(data) && data.length > 0 // Check if data is an array
      ? data
          .sort((a, b) => b.vbanner_id - a.vbanner_id) // Sort by ID in descending order
          .filter(
            (item) =>
              (item.vbanner_id &&
                item.vbanner_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.vendor_id &&
                item.vendor_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.name &&
                item.name.toLowerCase().includes(search.toLowerCase()))
          )
      : []; // Default to an empty array if data is not valid

  const handleSubmit = () => {
    let validationErrors = {};
    if (!bannerForm["name"] || !bannerForm["name"].trim()) {
      validationErrors.name = "Name is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDate(bannerForm.startDate)) {
      validationErrors.startDate = "From date is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDate(bannerForm.endDate)) {
      validationErrors.endDate = "To date is required.";
      setErrors(validationErrors);
      return;
    }

    if (!bannerForm["marketingPrice"] || !bannerForm["marketingPrice"].trim()) {
      validationErrors.marketingPrice = "Marketing price is required.";
      setErrors(validationErrors);
      return;
    }
    if (!bannerForm.image) {
      validationErrors.imageError = "Banner Image is required.";
      setErrors(validationErrors);
      return;
    }
    clearErrors();
    //  const formdata = new FormData();
    //     formdata.append("name", bannerForm["name"]);
    //     formdata.append(
    //       "imageurl",
    //       selectedImage ? selectedImage : bannerForm["image_url"]
    //     );
    //     formdata.append(
    //       "start_date",
    //       bannerForm.startDate ? convertDate(bannerForm.startDate) : null
    //     );
    //     formdata.append(
    //       "end_date",
    //       bannerForm.endDate ? convertDate(bannerForm.endDate) : null
    //     );
    //     formdata.append("offer_price", bannerForm["marketingPrice"]);
    if (isEditMode) {
      
         const saveBody= {
            "status":  bannerForm["status"] === "Active"
            ? 1
            : bannerForm["status"] === "Inactive"
            ? 0
            : "",
            "reason": bannerForm["reason"]? bannerForm["reason"]:""
        }
      
      
        const updateUrl = urls("updateAdminVendorBannersReason", bannerForm["id"]);
    
      fetchUpdateData(updateUrl, saveBody);
    }
  };
  const handleClose = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);
    clearErrors();
    if (isEditMode) {
      if (updateBannersData && updateBannersData["status"] === true) {
        initializeBanners();
        setOpen(false);
      }
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };
  return (
    <Box sx={{ padding: 2, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{ width: "30%", backgroundColor: "#FFF", borderRadius: 1 }}
        />
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Vendor ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Vendor Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Start Date</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>End Date</TableCell>

              <TableCell sx={{ fontWeight: "bold" }}>STATUS</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>ACTION</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((banner) => {
                  return (
                    <TableRow key={banner.vbanner_id}>
                      <TableCell>{banner.vbanner_id}</TableCell>
                      <TableCell>{banner.vendor_id}</TableCell>
                      <TableCell>{banner.name}</TableCell>
                      <TableCell>
                        {banner.image_url ? (
                          <img
                            src={banner.image_url}
                            alt="logo"
                            width={40}
                            height={40}
                          />
                        ) : (
                          "No Image"
                        )}
                      </TableCell>
                      <TableCell>
                        {convertYearMonthDateToMonthDateYear(banner.start_date)}
                      </TableCell>
                      <TableCell>
                        {convertYearMonthDateToMonthDateYear(banner.end_date)}
                      </TableCell>

                      <TableCell>
                        <Typography
                          color={
                            banner.status === "Active"
                              ? "green"
                              : banner.status === "Inactive"
                              ? "red"
                              : "orange"
                          }
                        >
                          {banner.status == 1
                            ? "Active"
                            : banner.status == 0
                            ? "Inactive"
                            : ""}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <MoreVertIcon
                          onClick={(e) => handleMenuOpen(e, banner.vbanner_id)}
                        />
                        <Menu
                          anchorEl={anchorEl}
                          open={
                            Boolean(anchorEl) &&
                            selectedBannerId === banner.vbanner_id
                          }
                          onClose={handleMenuClose}
                        >
                          <MenuItem onClick={() => handleView(banner)}>
                            View
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleDelete(banner.vbanner_id)}
                          >
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  );
                })
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      >
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%", // Makes the modal responsive to smaller screens
            maxWidth: 700, // Restricts maximum width for better readability
            height: "auto", // Adjusts height automatically based on content
            maxHeight: "80vh", // Prevents the modal from exceeding the viewport height
            overflowY: "auto", // Adds scrolling if content exceeds the max height
            bgcolor: "background.paper",
            borderRadius: 3, // Slightly larger rounded corners for a modern look
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)", // Softer and more elevated shadow
            p: 4, // Padding inside the modal for spacing
            // Hide the scrollbar
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none", // For Firefox
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setOpen(false)}
          >
            <Close />
          </IconButton>
          <Typography variant="h6" mb={2}>
            {isEditMode ? "View Vendor add banner details" : "Add Slider"}
          </Typography>
          <TextField
            name="vendorId"
            label="Vendor ID"
            fullWidth
            contentEditable={false}
            margin="dense"
            value={bannerForm.vendorId}
            onChange={(e) =>
              setBannerForm({
                ...bannerForm,
                vendorId: e.target.value,
              })
            }
            disabled
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            name="vendorName"
            label="Vendor Name"
            fullWidth
            contentEditable={false}
            margin="dense"
            value={bannerForm.name}
            onChange={(e) =>
              setBannerForm({
                ...bannerForm,
                name: e.target.value,
              })
            }
            disabled
            InputProps={{
              readOnly: true,
            }}
            error={!!errors.name}
            helperText={
              errors.name && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.name}
                </Typography>
              )
            }
          />

          <Box
            sx={{ flex: 1, mt: 2, display: "flex", flexDirection: "column" }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Start Date"
               
                value={
                  bannerForm.startDate ? new Date(bannerForm.startDate) : null
                }
                onChange={(newValue) => {
                  setBannerForm({
                    ...bannerForm,
                    startDate: newValue,
                  });

                  // Clear error if the date is valid
                  if (newValue) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      startDate: null,
                    }));
                  }
                }}
                disabled
                InputProps={{
                  readOnly: true,
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth sx={{ mb: 4 }} />
                )}
              />
              {errors.startDate && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.startDate}
                </Typography>
              )}
            </LocalizationProvider>
          </Box>
          <Box
            sx={{ flex: 1, mt: 2, display: "flex", flexDirection: "column" }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="End Date"
                value={bannerForm.endDate ? new Date(bannerForm.endDate) : null}
                onChange={(newValue) => {
                  setBannerForm({
                    ...bannerForm,
                    endDate: newValue,
                  });

                  // Clear error if the date is valid
                  if (newValue) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      endDate: null,
                    }));
                  }
                }}
                disabled
                InputProps={{
                  readOnly: true,
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth sx={{ mb: 4 }} />
                )}
              />
              {errors.endDate && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.endDate}
                </Typography>
              )}
            </LocalizationProvider>
          </Box>
          <TextField
            name="marketingPrice"
            label="Marketing Price"
            fullWidth
            contentEditable={false}
            margin="dense"
            value={bannerForm.marketingPrice}
            onChange={(e) =>
              setBannerForm({
                ...bannerForm,
                marketingPrice: e.target.value,
              })
            }
            disabled
            InputProps={{
              readOnly: true,
            }}
            error={!!errors.marketingPrice}
            helperText={
              errors.marketingPrice && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.marketingPrice}
                </Typography>
              )
            }
          />

          <input type="file" accept="image/*" disabled onChange={handleImageUpload} />
          {bannerForm.image && (
            <img src={bannerForm.image} alt="Preview" width={50} height={50} />
          )}
          {errors.imageError && (
            <helperText>
              <Typography
                sx={{
                  mt: 2,
                  color: "red",
                  fontSize: 12,
                }}
              >
                {errors.imageError}
              </Typography>
            </helperText>
          )}
          {isEditMode && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="status-label">Status</InputLabel>
              <Select
                labelId="status-label"
                id="status-select"
                value={bannerForm?.status || ""}
                onChange={(e) =>
                  setBannerForm({
                    ...bannerForm,
                    status: e.target.value,
                  })
                }
                label="Status"
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          )}
          {isEditMode && bannerForm.status === "Inactive" && (
            <TextField
              name="reason"
              label="Reason"
              fullWidth
              margin="dense"
              value={bannerForm.reason || ""}
              onChange={(e) =>
                setBannerForm({
                  ...bannerForm,
                  reason: e.target.value,
                })
              }
              sx={{ mt: 2 }}
            />
          )}
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleModalClose}
            >
              Cancel
            </Button>
            <Button variant="contained" color="success" onClick={handleSubmit}>
              {isEditMode ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminVendorAddBanners;
